import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { ParadiseOverviewExpandable } from "src/components/Paradise/ParadiseOverviewExpandable"
import { ParadiseSettingStatic } from "src/components/Paradise/ParadiseSettings/ParadiseSettingStatic"
import { CopyWrapper } from "src/components/Paradise/sharedStyles"
import { TParadiseLLMPrompt } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import { Routes } from "src/router/routes"
import { CopyText } from "src/ui/CopyText/CopyText"
import { InternalLink } from "src/ui/Link/InternalLink"
import { spacing } from "src/ui/spacing"
import { formatUtcDate } from "src/utils/l10n"

export function ParadiseLLMPromptOverview({
  prompt,
}: {
  prompt: TParadiseLLMPrompt
}) {
  return (
    <Box>
      <ParadiseOverviewExpandable rawJson={prompt}>
        <ParadiseSettingStatic
          title="Prompt id"
          value={
            <CopyWrapper>
              <Text variant="bodyS">{prompt.id}</Text>
              <CopyText value={prompt.id} copiedText="Copied prompt ID" />
            </CopyWrapper>
          }
        />

        <ParadiseSettingStatic
          title="Name"
          value={<Text variant="bodyS">{prompt.name}</Text>}
        />

        <ParadiseSettingStatic
          title="Category"
          value={<Text variant="bodyS">{prompt.category}</Text>}
        />

        <ParadiseSettingStatic
          title="Created by"
          value={
            <div>
              <InternalLink
                to={Routes.ParadiseUser.location(prompt.created_by)}
              >
                {prompt.created_by}
              </InternalLink>
              <CopyText value={prompt.created_by} copiedText="Copied!" />
            </div>
          }
        />

        <ParadiseSettingStatic
          title="Created at"
          value={formatUtcDate({ date: prompt.created_at })}
        />

        <ParadiseSettingStatic
          title="Updated at"
          value={formatUtcDate({ date: prompt.updated_at })}
        />
      </ParadiseOverviewExpandable>
    </Box>
  )
}

const Box = styled.div`
  display: grid;
  gap: ${spacing.L};
`
